export default __webpack_public_path__ + "36387b71bf25f0d64dd21702a6b2206a.png";